export default __webpack_public_path__ + "static/media/EM0333.34I-41685_-24967_0.7e6a6189.jpg";